const ButtonComponent = ({ value, onClick, disabled, type }) => {
  return (
    <button
      className={`bi-custom-button 
        ${disabled ? "bi-disabled-button" : ""}`}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      {value}
    </button>
  );
};
export default ButtonComponent;